// @tennis-matches/ui/tournament-setup/steps – Clubmeisterschaft-Regeln (kein Schleifchen-Feintuning)

import React from "react";
import { Check } from "lucide-react";

/**
 * Clubmeisterschaft-Regeln (v1):
 * - scoring: bo3 | mtb
 * - setEnd: open | tb (optional)
 *
 * Props:
 * - t
 * - value: { scoring, setEnd }
 * - onChange(next)
 * - format: "singles" | "fixedDoubles"
 */
export function ClubRulesStep({ t, value, onChange, format }) {
  const v = value && typeof value === "object" ? value : {};
  const scoring = v.scoring || (format === "fixedDoubles" ? "mtb" : "bo3");
  const setEnd = v.setEnd || "tb";

  const set = (patch) => onChange({ ...v, ...patch });

  return (
    <div className="tm-wizard-card tm-wizard-card--mb-lg">
      <span className="tm-wizard-card__label">{t("club.rules.title")}</span>

      <div className="tm-wizard-mode-cards tm-wizard-mode-cards--v0">
        <button
          type="button"
          className={`tm-wizard-card tm-wizard-card--selectable tm-wizard-card--mode ${scoring === "bo3" ? "tm-wizard-card--selected tm-wizard-card--valid" : ""}`}
          onClick={() => set({ scoring: "bo3" })}
          aria-pressed={scoring === "bo3"}
        >
          {scoring === "bo3" ? <span className="tm-wizard-card__check" aria-hidden><Check className="tm-wizard-icon tm-wizard-icon--sm" /></span> : null}
          <span className="tm-wizard-card__value">{t("club.rules.scoring.bo3")}</span>
          <span className="tm-wizard-card__desc">{t("club.rules.scoring.bo3.desc")}</span>
        </button>

        <button
          type="button"
          className={`tm-wizard-card tm-wizard-card--selectable tm-wizard-card--mode ${scoring === "mtb" ? "tm-wizard-card--selected tm-wizard-card--valid" : ""}`}
          onClick={() => set({ scoring: "mtb" })}
          aria-pressed={scoring === "mtb"}
        >
          {scoring === "mtb" ? <span className="tm-wizard-card__check" aria-hidden><Check className="tm-wizard-icon tm-wizard-icon--sm" /></span> : null}
          <span className="tm-wizard-card__value">{t("club.rules.scoring.mtb")}</span>
          <span className="tm-wizard-card__desc">{t("club.rules.scoring.mtb.desc")}</span>
        </button>
      </div>

      <div className="tm-wizard-scoring-section tm-wizard-card--mt-lg">
        <span className="tm-wizard-scoring-section__label">{t("club.rules.setEnd.title")}</span>
        <div className="tm-wizard-mode-cards tm-wizard-mode-cards--compact">
          <button
            type="button"
            className={`tm-wizard-card tm-wizard-card--selectable tm-wizard-card--mode ${setEnd === "tb" ? "tm-wizard-card--selected tm-wizard-card--valid" : ""}`}
            onClick={() => set({ setEnd: "tb" })}
            aria-pressed={setEnd === "tb"}
          >
            {setEnd === "tb" ? <span className="tm-wizard-card__check" aria-hidden><Check className="tm-wizard-icon tm-wizard-icon--sm" /></span> : null}
            <span className="tm-wizard-card__value">{t("club.rules.setEnd.tb")}</span>
            <span className="tm-wizard-card__desc">{t("club.rules.setEnd.tb.desc")}</span>
          </button>

          <button
            type="button"
            className={`tm-wizard-card tm-wizard-card--selectable tm-wizard-card--mode ${setEnd === "open" ? "tm-wizard-card--selected tm-wizard-card--valid" : ""}`}
            onClick={() => set({ setEnd: "open" })}
            aria-pressed={setEnd === "open"}
          >
            {setEnd === "open" ? <span className="tm-wizard-card__check" aria-hidden><Check className="tm-wizard-icon tm-wizard-icon--sm" /></span> : null}
            <span className="tm-wizard-card__value">{t("club.rules.setEnd.open")}</span>
            <span className="tm-wizard-card__desc">{t("club.rules.setEnd.open.desc")}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
